import { baseThemeValues } from 'constants/common';

const cardBaseProps = {
  borderRadius: '8px',
  borderWidth: '1px',
};

const indicatorBaseProps = {
  borderRadius: '50%',
};

const titleFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 500,
};

const valueFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '15px',
  fontWeight: 600,
};

const hintFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 400,
};

export const resetParameterTheme = {
  card: {
    active: {
      ...cardBaseProps,
      bg: 'palette.primary.10:0.6',
      borderColor: 'palette.primary.50',
    },
    base: {
      ...cardBaseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.40',
    },
    disabled: {
      ...cardBaseProps,
      bg: 'palette.tertiary.20:0.3',
      borderColor: 'palette.tertiary.30',
    },
    hint: {
      ...hintFont,
      text: 'palette.tertiary.50',
    },
    hover: {
      ...cardBaseProps,
      bg: 'palette.tertiary.20:0.3',
      borderColor: 'palette.tertiary.50',
    },
    indicator: {
      active: {
        ...indicatorBaseProps,
        borderColor: 'palette.primary.50',
        borderWidth: '6px',
      },
      base: {
        ...indicatorBaseProps,
        borderColor: 'palette.tertiary.50',
        borderWidth: '2px',
      },
    },
    title: {
      ...titleFont,
      text: 'palette.tertiary.60',
    },
    valueText: {
      ...valueFont,
      text: 'palette.tertiary.95',
    },
  },
};
